const { same } = require('../utils');

exports.computeHasHeaderRowFromTables = tables => same(tables, 'hasHeaderRow', false);
